export const DISCIPLINE_CHIP_COLORS = [
    { backgroundColor: '#e8f2ff', color: '#0b66d8' },
    { backgroundColor: '#e7f7ef', color: '#047857' },
    { backgroundColor: '#fff4de', color: '#b45309' },
    { backgroundColor: '#f3e8ff', color: '#7e22ce' },
    { backgroundColor: '#ffe8ee', color: '#be123c' },
    { backgroundColor: '#e7f7fb', color: '#0e7490' },
    { backgroundColor: '#eef2ff', color: '#4338ca' },
    { backgroundColor: '#f0fdf4', color: '#15803d' }
];

export const getDisciplineChipColors = (label) => {
    const value = String(label || '');
    const hash = value.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return DISCIPLINE_CHIP_COLORS[hash % DISCIPLINE_CHIP_COLORS.length];
};

export const getDisciplineChipSx = (label) => {
    const colors = getDisciplineChipColors(label);

    return {
        height: 28,
        borderRadius: 2,
        backgroundColor: colors.backgroundColor,
        color: colors.color,
        fontWeight: 800,
        fontSize: '0.82rem',
        '& .MuiChip-label': { px: 1.4 }
    };
};

export const competitionTypeChipSx = {
    height: 28,
    borderRadius: 2,
    backgroundColor: '#d9d2f3',
    color: '#4c3a8d',
    fontWeight: 800,
    fontSize: '0.82rem',
    '& .MuiChip-label': { px: 1.4 }
};
